import { Link } from "react-router-dom";

export default function NotFound() {
    return (
    <div className="relative min-h-screen bg-[#0D1117] flex items-start justify-center px-4 sm:px-6 lg:px-8 pt-28">

        {/* Background graphique */}
        <div className="absolute bottom-0 right-0 overflow-hidden lg:inset-y-0">
        <div className="w-auto h-full bg-gradient-to-tr from-[#1F6FEB]/20 to-[#3B82F6]/10 rounded-full transform rotate-45 scale-150"></div>
        </div>

        {/* Card */}
        <div className="relative z-10 bg-[#161B22] shadow-[0_0_20px_#3B82F6]/20 rounded-2xl p-10 max-w-md w-full text-center">

        <h1 className="text-6xl font-bold text-[#1F6FEB] mb-4">404</h1>

        <p className="text-xl font-semibold text-[#E6EDF3] mb-2">
            Page Not Found
        </p>

        <p className="text-[#8B949E] mb-8">
            Oops! The page you’re looking for doesn’t exist or has been moved.
        </p>

        <Link
            to="/"
            className="inline-block bg-[#1F6FEB] hover:bg-[#388BFD] text-white font-semibold py-3 px-6 rounded-xl transition shadow-[0_0_10px_#1F6FEB]/30"
        >
            Go Back Home 🏠
        </Link>
        </div>
    </div>
    );
}
